export class Session{
    constructor(
        public miembroID:number=0,
        public centro:number=0,
        public grupo:number,
        public municipio:number=0,
        public active:number,
        public subactive:number,
       public id:number,
       public token: string,
       public name:string,
       public foto:string,
       public access:string[],
       public empresa:number,
       public lock:number,
       public CanNot:number,
       public msj:string[],
       public sky:string[],
       public flag:number,
       public moneda:string,
       public carpeta: string,
       public path:string, 
       public sessionvariable=[]
       ){}

}